/*@ngInject*/
const ExternalAccountModalController = function ($rootScope, $scope, $uibModalInstance, coreConstant, currentUserModel, localization, loadingBarHandler, externalAccountRepository) {

    localization.getTranslations().then(function (translations) {

        let fillerText = 'thisIsFiller',
            isValueChange = false;

        $scope.title = _.get(translations, 'externalAccount.title');
        $scope.cancelButton = _.get(translations, 'externalAccount.cancelButton');
        $scope.okButton = _.get(translations, 'externalAccount.okButton');

        $scope.viewModel = {
            'externalAccounts': null
        };

        $scope.isComplete = function(externalAccount){
            return !_.isNil(externalAccount.username) && !_.isNil(externalAccount.password) && !_.isNil(externalAccount.verifyPassword) && externalAccount.password === externalAccount.verifyPassword
        };

        $scope.isInvalid = function(externalAccount){
            let fieldPopulated = !_.isNil(externalAccount.username) || !_.isNil(externalAccount.password) || !_.isNil(externalAccount.verifyPassword),
                fieldBlank = _.isNil(externalAccount.username) || _.isNil(externalAccount.password) || _.isNil(externalAccount.verifyPassword),
                passwordMismatch = (!_.isNil(externalAccount.password) && !_.isNil(externalAccount.verifyPassword) && externalAccount.password !== externalAccount.verifyPassword);
            return fieldPopulated && fieldBlank || passwordMismatch;
        };

        $scope.onConfirm = function () {
            let accountsToSave = [],
                userId = currentUserModel.getCurrentUser().userId;

            loadingBarHandler.showLoadingBar('externalAccount.savingLoadingBar');
            _.each($scope.viewModel.externalAccounts, function (account) {
                if (!_.isNil(account.username) && !_.isNil(account.password) && !_.isNil(account.verifyPassword)) {
                    if(account.password === fillerText || account.verifyPassword === fillerText){
                        account.password = account.verifyPassword = null;
                    }
                    accountsToSave.push(account);
                }
            });
            externalAccountRepository.save(userId, accountsToSave).finally(function () {
                loadingBarHandler.hideLoadingBar();
            });
            $uibModalInstance.close();
        };

        $scope.onCancel = function () {
            $uibModalInstance.close();
        };

        $scope.canEnableConfirmButton = function () {

            let validateArr = [],
                isValid;

            if(isValueChange) {
                _.each($scope.viewModel.externalAccounts, function (externalAccount) {

                    isValid = (_.isNil(externalAccount.username) && _.isNil(externalAccount.password) && _.isNil(externalAccount.verifyPassword)) ||
                        (!_.isNil(externalAccount.username) && !_.isNil(externalAccount.password) && !_.isNil(externalAccount.verifyPassword) && externalAccount.password === externalAccount.verifyPassword)
                    validateArr.push(isValid);
                });
                return validateArr.indexOf(false) > -1 ? true : false;
            } else {
                return true;
            }
        };

        $scope.showIncorrectPassword = function(externalAccount) {
            return (!_.isNil(externalAccount.password) && !_.isNil(externalAccount.verifyPassword) && externalAccount.password !== externalAccount.verifyPassword);
        };

        $scope.init = function () {
            let userId = currentUserModel.getCurrentUser().userId;
            externalAccountRepository.getExternalAccounts(userId).then(function (externalAccounts) {
                _.each(externalAccounts, function (externalAccount) {
                    if(!_.isEmpty(externalAccount.username)) {
                        externalAccount.verifyPassword = externalAccount.password = fillerText;
                    }
                });
                $scope.viewModel.externalAccounts = externalAccounts;
            });
        };

        $scope.onChange = function () {
            isValueChange = true;
        };

        $scope.init();
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('ums')
    .controller('externalAccountModalController', ExternalAccountModalController);
